import React from 'react'

const TextAreaWrapper = React.forwardRef((props, ref) => (
  <div className='row'>
    <div className='col-sm-12'>
      <label className='region-label'>{props.label}</label>
      <textarea {...props} ref={ref} className='form-control' rows='4'></textarea>
    </div>
  </div>
))

export default TextAreaWrapper
